import { render, staticRenderFns } from "./DetailsCategory.vue?vue&type=template&id=2c416a7a"
import script from "./DetailsCategory.vue?vue&type=script&lang=js"
export * from "./DetailsCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports